import { Component, DoCheck, OnDestroy } from '@angular/core';
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";

import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";

@Component({
  selector: 'app-simple-value-widget',
  templateUrl: './latest-simple-widget.component.html',
  styleUrls: ['./latest-simple-widget.component.css']
})
export class LatestSimpleWidgetComponent extends MultiSourceMultiValueWidget implements DoCheck {
  
  ranges: any[] = [];
  point: SharedPoint;
  highlighted: boolean = false;

  ngDoCheck(){
    this.ranges.push(Object.assign((<any>this.widget).default, {style:"default"}));
    this.ranges.push(Object.assign((<any>this.widget).primary, {style:"primary"}));
    this.ranges.push(Object.assign((<any>this.widget).success, {style:"success"}));
    this.ranges.push(Object.assign((<any>this.widget).info,    {style:"info"}));
    this.ranges.push(Object.assign((<any>this.widget).warning, {style:"warning"}));
    this.ranges.push(Object.assign((<any>this.widget).danger,  {style:"danger"}));
  }

  liveDataOnly(): boolean {
    return (<any>this.widget).period == null || (<any>this.widget).period == "";
  }

  override eventTypes: string[] = ["timeSeriesHover", "timeSeriesUnhover"];
  override timeSeriesEvent(type: string, uri: string): void {
    if (type === 'timeSeriesHover') {
      this.highlighted = true;
    } else if (type === 'timeSeriesUnhover') {
      this.highlighted = false;
    }
  }

  override widgetDataLoadComplete(): void {
      
  }

  hover(){
    this.events.trigger('timeSeriesHover', (<any>this.widget)?.timeSeriesList[0].uri, null);
  }

  unhover(){
    this.events.trigger('timeSeriesUnhover', (<any>this.widget)?.timeSeriesList[0].uri, null);  
  }

  widgetBeforeInit(): void {
    
  }

  widgetAfterInit(): void {
  }

  seriesCache: SharedSeries;

  widgetLiveDataLoaded(s: any) {
    if (s != null && s.uri != null){
      if (this.seriesCache == null){
        this.seriesCache = {uri:s.uri,values:[]} as SharedSeries;
      }
      // pop the first item, push the new one
      if (this.seriesCache) {
        this.seriesCache.values.pop();
        const value = Math.round(s.point.value*1000)/1000;
        this.seriesCache.values.push({uri:s.uri, value:value, timeStamp: s.point.timeStamp} as SharedPoint)
      }
      this.widgetDataLoaded(this.seriesCache);
    }
  }

  
  widgetDataLoaded(series: SharedSeries): void {
    this.seriesCache = series;
    if ((<any>this.widget).display == "Average"){
      const sum = series.values.reduce((a, b) => a + b.value, 0);
      const avg = (sum / series.values.length) || 0;
      this.point = {uri:series.uri, value:avg} as SharedPoint;
    }
    else if ((<any>this.widget).display == "Maximum"){
      this.point = series.values.sort((a,b)=>b.value-a.value)[0];
    }
    else if ((<any>this.widget).display == "Minimum"){
      var sorted = series.values.sort((a,b)=>b.value-a.value);
      this.point = sorted[sorted.length-1];
    }
    else if ((<any>this.widget).display == "Change"){
      var first = series.values[0].value;
      var last = series.values[series.values.length-1].value;
      this.point = {uri:series.uri, value:(last-first)} as SharedPoint;
    }
    else if ((<any>this.widget).display == "Total"){
      var total = 0;
      for (let tv of series.values){
        total += tv.value;
      }      
      this.point = {uri:series.uri, value:total} as SharedPoint;
    }
    else if (series != null) {
      /* assume latest */
      this.point = series.values[series.values.length-1];
    }
    else {
      
    }
  }

  widgetDataLoadTimeout(){
   
  }


  public getStyle(point:any){
    var opacity = "bg-opacity-30";
    if ((<any>this.widget).opacity != null){
      opacity = "bg-opacity-" + (<any>this.widget).opacity;
    }
    if (point && point.value != null){
      for (let range of this.ranges){
        if (range.min != null && range.max != null && range.min <= point.value && range.max >= point.value) {
          return "bg-" + range.style + " " + opacity;
        }
      }
    }
    // no data loaded, so default to offline
    return "bg-white bg-opacity-10";// + " " + opacity;
  }

  public getIcon(point:any) {
    if (point && point.value != null) {
      for (let range of this.ranges){
        if (range.min != null && range.max != null && range.min <= point.value && range.max >= point.value) {
          return range.icon;
        }
      }
    }
    return "";
  }

  public isNaN(val){
    return typeof val != 'number';
  }

}
